import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import humanTime from 'flarum/common/helpers/humanTime';
import classList from 'flarum/common/utils/classList';
import SectionIcon from './SectionIcon';
import { sectionNumber } from '../utils/sections';
/**
 * Hairline grid of numbered cards, as "Разделы портала" / "Темы раздела" on the portal.
 * Used for sections on the home page and for subsections on a section page.
 */
export default class SectionGrid extends Component {
  view() {
    return m("ul", {
      className: classList('TpGrid', `TpGrid--${this.attrs.variant}`)
    }, this.attrs.items.map(item => this.card(item)));
  }
  card(_ref) {
    let {
      tag,
      number,
      children
    } = _ref;
    const t = function (key, params) {
      if (params === void 0) {
        params = {};
      }
      return app.translator.trans(`tarotportal-theme.forum.stats.${key}`, params);
    };
    const last = tag.lastPostedAt();
    return m("li", {
      className: classList('TpCard', `TpCard--${tag.slug()}`)
    }, m("div", {
      className: "TpCard-top"
    }, m("span", {
      className: "TpNum"
    }, number), this.attrs.variant === 'sections' ? m(SectionIcon, {
      model: tag
    }) : m("span", {
      className: "TpMeta"
    }, t('discussions', {
      count: tag.discussionCount()
    }))), m("h3", {
      className: "TpCard-title"
    }, m(Link, {
      href: app.route.tag(tag)
    }, tag.name())), tag.description() && m("p", {
      className: "TpCard-text"
    }, tag.description()), children && children.length > 0 && m("ul", {
      className: "TpCard-children"
    }, children.map(child => m("li", null, m(Link, {
      href: app.route.tag(child)
    }, child.name())))), m("p", {
      className: "TpCard-meta TpMeta"
    }, this.attrs.variant === 'sections' && [t('subsections', {
      count: children?.length || 0
    }), ' · ', t('discussions', {
      count: tag.discussionCount()
    })], last && [this.attrs.variant === 'sections' ? ' · ' : '', t('last_activity', {
      ago: humanTime(last)
    })]), this.attrs.variant === 'subsections' && m(Link, {
      className: "TpArrowLink",
      href: app.route.tag(tag)
    }, app.translator.trans('tarotportal-theme.forum.section.go'), " ", m("span", {
      className: "TpArrowLink-arrow"
    }, "\u2192")));
  }
}
export { sectionNumber };
flarum.reg.add('tarotportal-theme', 'forum/components/SectionGrid', SectionGrid);